import { BaseGetInputModel } from "../../../../../../../../models/http/InputModel/BaseGetInputModel"

type MypageNovelNovelIdChapterChapterIdPlateGetParams = {
  novelId: number
  chapterId: number
  offset?: number
  limit?: number
}

export class MypageNovelNovelIdChapterChapterIdPlateGetInputModel extends BaseGetInputModel {
  constructor(
    private params: MypageNovelNovelIdChapterChapterIdPlateGetParams,
  ) {
    super()
  }

  get pathParams() {
    return {
      novel_id: this.params.novelId.toString(),
      chapter_id: this.params.chapterId.toString(),
    }
  }

  get query(): URLSearchParams {
    const queryParams: {
      limit?: string
      offset?: string
    } = {}

    if (this.params.limit !== undefined) {
      queryParams.limit = this.params.limit.toString()
    }

    if (this.params.offset !== undefined) {
      queryParams.offset = this.params.offset.toString()
    }

    return new URLSearchParams(queryParams)
  }
}
